<template>
    <ol>
        <li :class="{ 'active' : state == 'send_email' }">
            <div>メールアドレス送信</div>
        </li>
        <li :class="{ 'active' : state == 'register_provisional_complete' }">
            <div>仮登録完了</div>
        </li>
        <li :class="{ 'active' : state == 'register' }">
            <div>本登録</div>
        </li>
        <li :class="{ 'active' : state == 'first_update' }">
            <div>初回ログイン</div>
        </li>
        <li :class="{ 'active' : state == 'get_started' }">
            <div>利用開始</div>
        </li>
        <li>
            <div></div>
        </li>
    </ol>
</template>

<script>
export default {
    name: 'UserSignupStep',
    
    props: {
        state: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss" scoped>
ol {
    display: flex;
    max-width: 700px;
    counter-reset: number;
    margin: 10px auto 0 auto;
    overflow-x: auto;   
    padding: 0;

    @media (max-width: 600px) {
        flex-wrap: wrap;
        justify-content: center;
    }
    
    li {
        flex: 0 0 auto;
        flex-grow: 1;
        position: relative;
        display: inline-block;
        color: #9A9A9A;
        font-size: 15px;
        font-weight: bold;
        text-align: center;
        width: 1vw;

        @media (max-width: 600px) {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            flex: 0 0 33.333%; // 基本は3つで1行
        }

        @media (max-width: 470px) {
            justify-content: start;
            flex: 0 0 43%; // 基本は3つで1行
            margin: 5px 0;
        }
        

        &::before {
            counter-increment: number;
            content: counter(number);
            position: relative;
            top: 0px;
            display: inline-block;
            width: 50px;
            height: 50px;
            line-height: 48px;
            color: #fff;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
            background: #ccc;
            border-radius: 50%;

            @media (max-width: 650px) {
                font-size: 18px;
                width: 40px;
                height: 40px;
                line-height: 40px;
            }

            @media (max-width: 600px) {
                font-size: 14px;
                width: 20px;
                height: 20px;
                line-height: 20px;
            }
        }

        &::after {
            content: '';
            position: absolute;
            right:-15px;
            top: 35px;
            display: inline-block;
            width: 24px;
            height: 3px;
            background: #F3F3F3;

            @media (max-width: 650px) {
                top: 25px;
            }

            @media (max-width: 600px) {
                display: none;
            }
        }

        &:nth-child(5) {
            &::after {
                display: none;
            }
        }

        &:last-child {
            display: none;

            &::after {
                display: none;
            }

            @media (max-width: 470px) {
                display: inline;
                opacity: 0;
            }
        }

        &.active {
            color: #00B8BF;
            &::before {
                background: #00B8BF;
            }
        }

        div {
            margin-top: 5px;
            font-size: 12px;

            @media (max-width: 650px) {
                font-size: 11px;
            }

            @media (max-width: 600px) {
                margin-top: 0;
                margin-left: 5px;
            }

            @media (max-width: 470px) {
                margin: auto;
            }
        }
    }
}
</style>
